// extracted by mini-css-extract-plugin
export default {"wrapper":"EmployeePage_wrapper__Rsao-"};